import React from 'react';
import { Link } from 'react-router-dom';

const MiniCart = ({ 
    cartItems, 
    isLoggedIn, 
    storagePath, 
    totalQuantity, 
    totalPrice, 
    onRemove, 
    toggleSidebar 
}) => {
    return (
        <div className="dropdn dropdn_fullheight minicart custom=-"
            onClick={() => toggleSidebar("dropdnMinicart")}>
            <span className={`dropdn-link js-dropdn-link minicart-link only-icon`}>
                <i className="icon-basket" />
                <span className="minicart-qty">{totalQuantity}</span>
                <span className="minicart-total hide-mobile"
                    style={{ display: "unset" }}
                >&nbsp;${totalPrice}</span>
            </span>
            {/* Note: The actual dropdown content is usually handled by a separate div or a sidebar in this theme, 
                but Header.js has cart_items_mapping which seems to be used elsewhere or planned. 
                In Header.js, the MiniCart listing is in a side panel. 
            */}
        </div>
    );
};

export default MiniCart;
